import { Link, useNavigate } from "react-router-dom";
import SuccessfullyModal from "../../../Modal/SuccessfullyModal";
import WarningModal from "../../../Modal/WarningModal";
import * as Validation from "../../../utils/helper/validation";
import * as APIS from "../../../utils/helper/enum";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import { changeTrigger } from "../../../redux/reducers/trigger";
import globalRequest from "../../../utils/global/globalRequest";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { useEffect, useState } from "react";
import { Typography, Button, Input, Form, Layout, Card, Flex, Checkbox } from "antd";
import { useTranslation } from "../../../context/TranslationContext";
const { Title } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { changeLocale } = useTranslation();
  const [rememberMe, setRememberMe] = useState(false);
  const [isSuccessfullyModalOpen, setIsSuccessfullyModalOpen] = useState(false);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [apiError, setApiError] = useState({});
  const [form] = Form.useForm();

  const handleSuccessfullyOk = () => {
    setIsSuccessfullyModalOpen(false);
  };

  const handleSuccessfullyCancel = () => {
    setIsSuccessfullyModalOpen(false);
  };

  const handleWarningModalOk = () => {
    setIsWarningModalOpen(false);
  };

  const handleWarningModalCancel = () => {
    setIsWarningModalOpen(false);
  };

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
    setApiError((prevError) => ({
      ...prevError,
      [name]: undefined, // Clear the error for the field
    }));
  };

  const handleSubmit = async (values) => {
    if (rememberMe) {
      Cookies.set("rememberedEmail", values.email, { expires: 30 });
      Cookies.set("rememberedPassword", values.password, { expires: 30 });
    } else {
      Cookies.remove("rememberedEmail");
      Cookies.remove("rememberedPassword");
    }
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(APIS?.ONBOARDING_APIS?.LOGIN, "post", values);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, apiResponse?.data?.token, "add", "single");
        const userDetails = apiResponse?.data?.userDetails;
        const decoded = jwtDecode(apiResponse?.data?.token);
        const user = decoded?.user || userDetails;
        const roleId = user?.roleId || userDetails?.roleId;
        const userRole = roleId === 1 ? "admin" : roleId === 5 ? "subadmin" : "admin";
        const branchIds = Array.isArray(userDetails?.branchIds)
          ? userDetails.branchIds
          : [];
        const dropzoneIds = Array.isArray(userDetails?.dropzoneId)
          ? userDetails.dropzoneId
          : [];

        const userData = {
          id: userDetails?.id || user?.id,
          role: userRole,
          roleId: roleId,
          firstName: userDetails?.firstName || user?.firstName,
          lastName: userDetails?.lastName || user?.lastName,
          email: userDetails?.email || user?.email,
          branch_ids: branchIds,
          dropzone_id: dropzoneIds,
          branchIds,
          dropZoneIds: dropzoneIds,
        };
        localStorage.setItem("userData", JSON.stringify(userData));

        const preferredLang = apiResponse?.data?.userDetails?.preferredLang;
        if (preferredLang) {
          addDeleteGetLocalStorage(storageKeys?.LANG, preferredLang, "add", "single");
          changeLocale(preferredLang);
        }
        dispatch(changeTrigger("loggedin"));

        const redirectURL = localStorage.getItem("redirectAfterLogin");

        // If the stored URL is for 'submit-order-qc', redirect back to it
        if (redirectURL && redirectURL.includes("/submit-order-qc")) {
          navigate(redirectURL); // Redirect to the original URL
          localStorage.removeItem("redirectAfterLogin"); // Clean up
        } else {
          //check roles and permissions
          const decoded = jwtDecode(apiResponse?.data?.token);
          let user = decoded?.user;
          if (user?.rolePermissionId === 1) navigate("/manage-QC");
          else {
            let permission = user?.rolePermission?.permissionJson;
            let redirectUrl = "";
            //check user management tab permission
            for (let row of permission) {
              if (row.moduleName === "Manage QC" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-QC";

              if (row.moduleName === "Manage Vendor" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-vendor";

              if (row.moduleName === "Manage Driver" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-driver";

              if (row.moduleName === "Manage Sub Admin" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-sub-admin";

              if (row.moduleName === "Roles" && row.view === 1 && redirectUrl === "") redirectUrl = "/roles-permissions";

              if (row.moduleName === "Zones" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-zones";

              if (row.moduleName === "Vehicle Type" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-vehicle-type";

              if (row.moduleName === "Packaging Type" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-packaging-type";

              if (row.moduleName === "Drop zone" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-drop-zone";

              if (row.moduleName === "Item Sensitivity" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-item-sensitivity";

              if (row.moduleName === "Subscriptions" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-subscription";

              if (row.moduleName === "Manage CMS" && row.view === 1 && redirectUrl === "") redirectUrl = "/privacy-policy";

              if (row.moduleName === "System Settings" && row.view === 1 && redirectUrl === "") redirectUrl = "/system-settings";

              if (row.moduleName === "Vendor Payouts" && row.view === 1 && redirectUrl === "") redirectUrl = "/vendor-payouts";

              if (row.moduleName === "Driver Payouts" && row.view === 1 && redirectUrl === "") redirectUrl = "/driver-payouts";

              if (row.moduleName === "Order Management" && row.view === 1 && redirectUrl === "") {
                redirectUrl = "/order-management";
              }

              if (row.moduleName === "Product Management" && row.view === 1 && redirectUrl === "") redirectUrl = "/product-management";

              if (row.moduleName === "Manage Modifiers" && row.view === 1 && redirectUrl === "") redirectUrl = "/manage-modifiers";

              if (
                (row.moduleName === "Sales By Zone Report" ||
                  row.moduleName === "Sales By Item Report" ||
                  row.moduleName === "Sales By Customer Report" ||
                  row.moduleName === "Sales By Order Type Report" ||
                  row.moduleName === "Sales By Delivery Mode Report" ||
                  row.moduleName === "Sales By Time Slot Report" ||
                  row.moduleName === "Sales By Vendor Report" ||
                  row.moduleName === "Sales By Driver Report" ||
                  row.moduleName === "Coupon Report" ||
                  row.moduleName === "Payment Report" ||
                  row.moduleName === "Sales Details Report" ||
                  row.moduleName === "Late Order Report" ||
                  row.moduleName === "Refund Order Report" ||
                  row.moduleName === "Cancelled Order Report") &&
                row.view === 1 &&
                redirectUrl === ""
              )
                redirectUrl = "/report";
            }

            if (redirectUrl !== "") navigate(redirectUrl);
            else navigate("/");
          }
        }
      } else {
        setApiError({ password: apiResponse.message });
      }
    } catch (e) {
      console.log(e);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    const rememberedEmail = Cookies.get("rememberedEmail");
    const rememberedPassword = Cookies.get("rememberedPassword");
    if (rememberedEmail && rememberedPassword) {
      form.setFieldsValue({
        email: rememberedEmail,
        password: rememberedPassword,
      });
      setRememberMe(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Flex
          gap="middle"
          align="center"
          justify="center"
          vertical
          style={{
            minHeight: "100vh",
            padding: "18px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            className="relative"
            style={{
              width: "100%",
              maxWidth: 500,
              boxSizing: "border-box",
              ...(window.innerWidth < 768 ? { width: "100%" } : {}),
            }}
          >
            <img src="QC_Logo.svg" alt="" className="mx-auto absolute top-[-80px] left-0 right-0" />
            <Title level={3} align={"center"}>
              Admin Login
            </Title>
            <Form
              form={form}
              onFinish={handleSubmit}
              layout="vertical"
              style={{
                width: "100%",
                marginTop: 24,
              }}
              initialValues={{
                remember: true,
              }}
              autoComplete="off"
            >
              <Form.Item
                label="E-mail"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter your email",
                  },
                  {
                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email address.",
                  },
                ]}
                validateTrigger={"onSubmit"}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    form.setFieldValue("email", value);
                    handleInputChange("email");
                  }}
                  placeholder="Please Enter Your Email"
                />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your password.",
                  },
                ]}
                help={apiError && apiError.password}
                validateStatus={apiError && apiError.password ? "error" : ""}
                validateTrigger={"onSubmit"}
              >
                <Input.Password
                  placeholder="Please Enter Your Password"
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    form.setFieldValue("password", value);
                    handleInputChange("password");
                  }}
                />
              </Form.Item>
              <Form.Item>
                <div className="block sm:flex items-center justify-between">
                  <Checkbox name="remember" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)}>
                    Remember me
                  </Checkbox>
                  <Link to="/forgot-password">
                    <Button className="p-0 font-semibold !text-[#176b53]" type="link">
                      Forgot Password
                    </Button>
                  </Link>
                </div>
              </Form.Item>
              <Button
                className="w-full mt-4"
                size="large"
                type="primary"
                htmlType="submit" //Success
              // onClick={showWarningModalModal} //Warning
              >
                Submit
              </Button>
            </Form>
          </Card>
        </Flex>
      </Layout>
      <SuccessfullyModal isOpen={isSuccessfullyModalOpen} onOk={handleSuccessfullyOk} onCancel={handleSuccessfullyCancel} />
      <WarningModal isOpen={isWarningModalOpen} onOk={handleWarningModalOk} onCancel={handleWarningModalCancel} />
    </>
  );
};
export default Login;
